var gbs = {
	//host: '/slsAdminApi', // 接口根地址。本地代理到slsadmin.api.sls.com,线上使用的是Nginx代理
	host: 'https://zcbp13910080117.com/251/public/index.php/api/v1/',
	db_prefix: 'solely', // 本地存储的key
	// 状态码字段
	api_status_key_field: 'solely_code',
	// 状态码value
	api_status_value_field: 100000,
	// 存放数据的字段
	api_data_field: '',
	api_custom: {
		404: function(res) {
			this.$store.dispatch('remove_userinfo').then(() => {
				this.$alert(res.status + ',' + res.msg + '！', '登录错误', {
					confirmButtonText: '确定',
					callback: action => {
						this.$router.push('/login')
					}
				})
			})
		}
	},
	menu: [{
			id: '0',
			name: '控制面板',
			icon: 'el-icon-s-platform',
			router: '/home/dashboard',
			button: ['添加', '添加任务', '编辑任务'],
			hasButton: [],
			isShow: true,
			parent: '0'
		},
		{
			id: '1',
			name: '用户管理',
			icon: 'el-icon-user-solid',
			isShow: true,
			children: [{
					id: '10',
					name: '管理员列表',
					router: '/home/adminLists',
					icon: 'reorder',
					isShow: true,
					button: ['编辑账号', '管理权限', '添加账号', '删除选中', '编辑信息', '添加信息'],
					hasButton: [],
					parent: '1'
				},
				{
					id: '11',
					name: '权限管理',
					router: '/home/access',
					icon: 'reorder',
					isShow: false,
					button: ['返回', '权限全选', '更新权限'],
					hasButton: [],
					parent: '1'
				},
				{
					id: '13',
					name: '配置列表',
					router: '/home/thirdApp',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '添加', '删除选中'],
					hasButton: [],
					parent: '1'
				},
				{
					id: '16',
					name: '项目配置',
					router: '/home/config',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '添加', '删除选中'],
					hasButton: [],
					parent: '1'
				},
				{
					id: '14',
					name: '角色管理',
					router: '/home/role',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '添加', '删除选中', '管理权限'],
					hasButton: [],
					parent: '1'
				},
				{
					id: '15',
					name: '用户管理',
					router: '/home/user',
					icon: 'reorder',
					isShow: true,
					button: ['编辑账号', '添加账号', '删除选中', '编辑信息', '添加信息','导出'],
					hasButton: [],
					parent: '1'
				},
				{
					id: '17',
					name: '企业用户',
					router: '/home/company',
					icon: 'reorder',
					isShow: true,
					button: ['编辑账号', '添加账号', '删除选中', '编辑信息', '添加信息','导出'],
					hasButton: [],
					parent: '1'
				}
			]
		},
		{
			id: '2',
			name: '内容管理',
			icon: 'el-icon-s-unfold',
			isShow: true,
			children: [{
					id: '21',
					name: '菜单管理',
					router: '/home/label',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加'],
					hasButton: [],
					parent: '2'
				},
				{
					id: '22',
					name: '文章管理',
					router: '/home/article',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加'],
					hasButton: [],
				},
				{
					id: '23',
					name: '首页内容',
					router: '/home/art',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加'],
					hasButton: [],
				},
				{
					id: '24',
					name: '隐私协议',
					router: '/home/protocol',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加'],
					hasButton: [],
				},
				{
					id: '25',
					name: '开票管理',
					router: '/home/message',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加','导出','导入'],
					hasButton: [],
				},
			]
		},
		
		
		
		
	]
}

var cbs = {
	/**
	 * ajax请求成功，返回的状态码不是200时调用
	 * @param  {object} err 返回的对象，包含错误码和错误信息
	 */
	statusError(err) {
		console.log('err')
		if (err.status !== 404) {
			this.$message({
				showClose: true,
				message: '返回错误：' + err.msg,
				type: 'error'
			})
		} else {
			this.$store.dispatch('remove_userinfo').then(() => {
				this.$alert(err.status + ',' + err.msg + '！', '登录错误', {
					confirmButtonText: '确定',
					callback: action => {
						this.$router.push('/login')
					}
				})
			})
		}
	},

	/**
	 * ajax请求网络出错时调用
	 */
	requestError(err) {
		this.$message({
			showClose: true,
			message: '请求错误：' + (err.response ? err.response.status : '') + ',' + (err.response ? err.response.statusText : ''),
			type: 'error'
		})
	}
}

export {
	gbs,
	cbs
}



// WEBPACK FOOTER //
// ./src/config/settings.js